<template>
  <div>
    <RevDrawer :has-back-button :name :title @back="onBack" @open="onOpen">
      <template #trigger="{ open }">
        <slot v-bind="{ open }" name="trigger" />
      </template>
      <template #body>
        <AsyncModalBody :is-error :is-loading :is-success>
          <template #content>
            <slot name="content" />
          </template>
        </AsyncModalBody>
      </template>
    </RevDrawer>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import { RevDrawer } from '@ds/components/Drawer'

import { STATUS } from './AsyncModal.constant'
import AsyncModalBody from './components/AsyncModalBody/AsyncModalBody.vue'

const props = withDefaults(
  defineProps<{
    name: string
    title: string
    fetch: () => void
    hasBackButton?: boolean
    onBack?: () => void
  }>(),
  {
    hasBackButton: false,
    onBack: undefined,
  },
)

const status = ref(STATUS.LOADING)
const isError = computed(() => status.value === STATUS.ERROR)
const isSuccess = computed(() => status.value === STATUS.SUCCESS)
const isLoading = computed(() => status.value === STATUS.LOADING)

async function onOpen() {
  status.value = STATUS.LOADING

  try {
    await props.fetch()
    status.value = STATUS.SUCCESS
  } catch {
    status.value = STATUS.ERROR
  }
}
</script>
